import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import BaggageRecheckImage from 'shared/icons/baggage_recheck.svg'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { TransferModal } from '../transfer-modal'

import { baggageRecheckList } from './constants/lists'
import s from './styles.module.scss'

export const BaggageRecheck = () => {
  const { openDialog } = useDialogBottomSheet()

  const { t } = useTranslation()

  const onOpenDialog = () => {
    openDialog({
      child: (
        <TransferModal
          title={t('transfer_details.baggage_recheck.title')}
          description={t('transfer_details.baggage_recheck.description')}
          subtitle={t('transfer_details.baggage_recheck.subtitle')}
          image={BaggageRecheckImage}
          list={baggageRecheckList}
        />
      ),
    })
  }
  return (
    <div
      className={s.baggageRecheck}
      onClick={onOpenDialog}
    >
      <h4 className={clsx(s.text, 'semi-bold-11')}>
        {t('transfer_details.baggage_recheck.title')}
      </h4>
      <AppIcon
        id={AllIcons.INFO}
        className={s.icon}
        height={16}
        width={16}
      />
    </div>
  )
}
